import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { colors, getResetByTag, rem } from './../../../styles';
var defaultStyles = /*#__PURE__*/css("border:", rem(1), " solid ", colors.coolGray_800, ";border-radius:inherit;display:block;height:100%;left:0;pointer-events:none;position:absolute;top:0;transition:box-shadow 0.2s,border-color 0.2s;width:100%;" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
var resetStyles = getResetByTag('div');
var StyledFormFieldStateWrapper = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "e3ex1020"
} : {
  target: "e3ex1020",
  label: "StyledFormFieldStateWrapper"
})(resetStyles, defaultStyles);
export default StyledFormFieldStateWrapper;